// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__Fv9jK","inlineCheckbox":"Checkbox_inlineCheckbox__s9vUb"};